module.exports = __webpack_public_path__ + "img/lincoln_memorial.2203719e.jpg";